import MyButton from "./MyButton.vue"
import MyInput from "./MyInput.vue"
import MyDialog from "./MyDialog.vue"
import MyA from "./MyA.vue"
import MyIcon from "./MyIcon.vue"

export default [
    MyButton,
    MyInput,
    MyDialog,
    MyA,
    MyIcon
]